import React from 'react';
import { Heart, Bone, Brain, Baby, Stethoscope, FlaskConical } from 'lucide-react';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: <Heart size={28} />,
      title: 'Cardiology',
      desc: 'Advanced heart care with state-of-the-art diagnostic and treatment facilities for all cardiac conditions including angiography, angioplasty, and bypass surgery.',
    },
    {
      icon: <Bone size={28} />,
      title: 'Orthopedics',
      desc: 'Complete bone and joint care including joint replacement, sports medicine, trauma surgery, and rehabilitation services for all musculoskeletal issues.',
    },
    {
      icon: <Brain size={28} />,
      title: 'Neurology',
      desc: 'Expert neurological care for brain, spine, and nervous system disorders with modern imaging technology and specialized neurosurgical procedures.',
    },
    {
      icon: <Baby size={28} />,
      title: 'Pediatrics',
      desc: 'Specialized care for infants, children, and adolescents with a child-friendly environment, vaccination programs, and developmental assessments.',
    },
    {
      icon: <Stethoscope size={28} />,
      title: 'General Medicine',
      desc: 'Primary healthcare services including preventive care, comprehensive health checkups, chronic disease management, and lifestyle counseling.',
    },
    {
      icon: <FlaskConical size={28} />,
      title: 'Diagnostics',
      desc: 'Full range of laboratory tests, advanced imaging (MRI, CT, X-ray), and pathology services with accurate and quick results delivered digitally.',
    },
  ];

  return (
    <div className="services-page">
      <section className="section">
        <div className="section-header">
          <h2>Our Medical Services</h2>
          <p>Comprehensive healthcare solutions tailored to your needs</p>
        </div>
        <div className="services-grid">
          {services.map((service, i) => (
            <div className="service-card-large" key={i}>
              <div className="service-icon-large">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
              <button className="service-btn">Learn More →</button>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Services;
